// Mirrors ReturnTo::SAFE_PATH in the API. A same-origin path is a single
// leading slash that is not followed by another slash (protocol-relative
// `//host`) or a backslash (browsers normalise `/\host` to `//host`), with no
// backslash anywhere else.
const SAFE_PATH = /^\/(?![/\\])[^\\]*$/;

export const isSafeReturnPath = (value: unknown): value is string =>
  typeof value === 'string' && SAFE_PATH.test(value);

/**
 * Returns `value` when it is a same-origin path, otherwise `fallback`.
 * Run anything that arrived via `?return_to=` through this before handing it
 * to navigate(), <Navigate>, or window.location.
 */
export const safeReturnPath = (value: unknown, fallback = '/'): string =>
  isSafeReturnPath(value) ? value : fallback;
